export default __webpack_public_path__ + "static/media/WorkspaceReminderSlack.dfd79156.png";